import React from 'react';
import PropTypes from 'prop-types';
import { SectionWrapper } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { resolveRenderField } from '../../../../../services/cms/HtmlResolver';

export const WhatsNotCoveredSection = ({
  whatsNotCoveredContent,
  dynamicValue,
  dropdownField,
  forceExpand,
  cmsTags
}) => {
  return (
    <div className="whatsNotCoveredSection">
      <SectionWrapper
        key="whatsNotCovered"
        customCssClass="accordionButtonClass"
        isOpen={forceExpand || false}
        headerButtonCustomLabel="What's not covered"
      >
        {whatsNotCoveredContent?.map(({ fullKey, field }) => (
          <React.Fragment key={fullKey}>
            {resolveRenderField({ field, key: fullKey, dynamicValue, dropdownField, cmsTags })}
          </React.Fragment>
        ))}
      </SectionWrapper>
    </div>
  );
};

WhatsNotCoveredSection.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  whatsNotCoveredContent: PropTypes.array,
  dynamicValue: PropTypes.object,
  dropdownField: PropTypes.object,
  forceExpand: PropTypes.bool,
  cmsTags: PropTypes.object
  /* eslint-disable react/forbid-prop-types */
};
